// extracted by mini-css-extract-plugin
export var infoItem = "_p7-2";
export var title = "_p7-0";
export var value = "_p7-1";